import request from '../utils/request'
import axios from 'axios'

export default class Base {
  axios = axios

  _request(method, url, body, options) {
    return request({
      url: url,
      method: method,
      data: body,
      ...options
    })
  }

  get(url, options) {
    return this._request('get', url, null, options)
  }

  del(url, options) {
    return this._request('delete', url, null, options)
  }

  put(url, body, options) {
    return this._request('put', url, body, options)
  }

  post(url, body, options) {
    return this._request('post', url, body, options)
  }
}
